import React from "react";
import { Link } from "react-router-dom";

export const planListColumns = ({handleEdit, handleDelete, PAGE_SIZE}) => [
  //  {
  //   label: "S.No",
  //   width: 50,
  //   render: (row, index, page) =>
  //     (page - 1) * PAGE_SIZE + index + 1,
  // },
  {
    label: "Plan",
    render: (row) => row.name,    
  },
  {
    label: "Plan Price",
    render: (row) => (
        <span>₹ {row.display_plan_price ?? 0}</span>
    )
  },
  {
    label: "Discounted Plan Price",
    render: (row) => (
        <span>₹ {row.price}</span>
    )
  },
  {
    label: "Agent Commission",
    render: (row) => (
      <div>
       {row.agentCommission ? row.agentCommission : 0}
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link  onClick={() => handleEdit(row._id)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        {/* <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li> */}
      </ul>
    ),
  },
];
